<div class="field-dialog__content__scroll disabled-content p-24" id="photos-videos" fusePerfectScrollbar>
  <div
    *ngIf="!approval.equipment.attachments || !approval.equipment.attachments.length"
    fxLayout="column"
    fxLayoutAlign="center center"
  >
    <p fxFlex="100" fxLayout="row">
      <mat-icon class="font-size-32">attach_file</mat-icon>
    </p>
    <div fxFlex="100" fxLayout="row">
      <span class="h3">Nenhum anexo</span>
    </div>
  </div>

  <div *ngIf="approval.equipment.attachments && approval.equipment.attachments.length">
    <div class="attachment w-100-p" *ngFor="let attachment of approval.equipment.attachments">
      <div fxLayout="row">
        <div class="attachment__preview" [style.backgroundImage]="'url(' + attachment.path + ')'"></div>
        <div fxLayout="column">
          <span class="attachment__name">{{ attachment.title || 'Anexo sem título' }}</span>
          <span class="attachment__time">{{ attachment.createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
          <a class="attachment__link" [href]="attachment.path" target="_blank">Ver original</a>
        </div>
      </div>
    </div>
  </div>
</div>
